import { render } from "./invalidUser.vue?vue&type=template&id=59a2408e"
import script from "./invalidUser.vue?vue&type=script&lang=js"
export * from "./invalidUser.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__